import { render, staticRenderFns } from "./BulkSend.vue?vue&type=template&id=71f2e48a&scoped=true&lang=pug"
import script from "./BulkSend.vue?vue&type=script&lang=js"
export * from "./BulkSend.vue?vue&type=script&lang=js"
import style0 from "./BulkSend.vue?vue&type=style&index=0&id=71f2e48a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f2e48a",
  null
  
)

export default component.exports